import $ from 'jquery'
import { setSameHeight, generateProductHTML } from '../abstracts/utils'

export default () => {
  $(() => {
    if (!$('body').hasClass('page-template-recommended-products')) return

    let $sectionProductModes = $('.section-product-modes')
    let $sectionProducts = $('.section-products')
    if ($sectionProducts.length) {
      setSameHeight($sectionProducts.find('.products.active .product .product__content'))
      $sectionProductModes.find('.product-mode').on('click', e => {
        if (! $(e.target).hasClass('active')) {
          let target = $(e.target).data('target')
          activeMode = target
          // remove current active
          $(e.target).parent().children('.product-mode').removeClass('active')
          $sectionProducts.find('.products').removeClass('active')
          // add active
          $(e.target).addClass('active')
          $sectionProducts.find('#' + target).addClass('active')
          setSameHeight($sectionProducts.find('.products.active .product .product__content'))
          handleLoadMoreBtn(activeMode)
        }
      })

      $sectionProducts.find('.load-more-cta a').on('click', () => {
        let nextPage = 0
        if (activeMode === 'products-new') {
          nextPage = currentNewProductsPage + 1
        } else {
          nextPage = currentPromotionalProductsPage + 1
        }
        $.get(window.endpoint + '/get-recommended-products', {
          mode: activeMode,
          page: nextPage
        })
          .done(res => {
            // console.log(res)
            let data = JSON.parse(res)
            // console.log(data)
            for (let i = 0; i < data.length; i++) {
              if (activeMode === 'products-new') {
                $sectionProducts.find('#products-new').append(generateProductHTML(data[i]))
              } else {
                $sectionProducts.find('#products-promotion').append(generateProductHTML(data[i]))
              }
            }
            if (activeMode === 'products-new') {
              currentNewProductsPage++
            } else {
              currentPromotionalProductsPage++
            }
            handleLoadMoreBtn(activeMode)
            setSameHeight($sectionProducts.find('.products.active .product .product__content'))
          })
          .fail(err => {
            console.log('err', err)
          })
      })
    }
  })
}

let activeMode = 'products-new'
let currentNewProductsPage = 1
let currentPromotionalProductsPage = 1

function handleLoadMoreBtn(activeMode) {
  if (activeMode === 'products-new') {
    /* eslint-disable */
    if (currentNewProductsPage >= localVar['new_products_max_num_pages']) {
      $('.section-products .load-more-cta').hide()
    } else {
      $('.section-products .load-more-cta').show()
      $('.section-products .load-more-cta a').attr('current-page', currentNewProductsPage)
    }
  } else {
    if (currentPromotionalProductsPage >= localVar['promotional_products_max_num_pages']) {
      $('.section-products .load-more-cta').hide()
    } else {
      $('.section-products .load-more-cta').show()
      $('.section-products .load-more-cta a').attr('current-page', currentPromotionalProductsPage)
    }
  }
}
